import {Injectable} from "@angular/core";
@Injectable()

export class Globals {
  username: String = "";
  loginStatus = false;
}



// WEBPACK FOOTER //
// /Users/sharvil/Desktop/fall17/adaptive/assign1/src/app/globals.ts